(() => {
  if (window.KarmaBraceletNotes) return;
  const config = JSON.parse(document.getElementById('ks-bracelet-note-config').textContent);
  const root = window.Shopify?.routes?.root || '/';
  const request = window.fetch.bind(window);
  const properties = ['Prelungire gratuită (cm în plus)', 'Free extension (extra cm)'];
  let queue = Promise.resolve();
  let cart = config.cart;
  let customerDraft;
  let checkoutBusy = false;
  const replayClicks = new WeakSet();
  const replayForms = new WeakSet();

  function customerNote(note) {
    return String(note || '')
      .replace(/(?:\r?\n){0,2}\[Prelungiri gratuite KarmaShop\][\s\S]*?\[\/Prelungiri gratuite KarmaShop\]/g, '')
      .split(/\r?\n/)
      .filter(line => !/^.+ — (?:prelungire|extension) \+\d+(?:[.,]\d+)? cm$/.test(line))
      .join('\n').trim();
  }

  function extensionLines(items) {
    const groups = new Map();
    (items || []).forEach(item => {
      const value = properties.map(key => item.properties?.[key]).find(value => value != null && value !== '');
      const cm = String(value ?? '').trim().replace(',', '.');
      if (!/^\d+(?:\.\d{1,2})?$/.test(cm) || Number(cm) <= 0 || Number(cm) > 3 || item.quantity < 1) return;
      const key = JSON.stringify([item.variant_id || item.id || item.title, Number(cm)]);
      const group = groups.get(key);
      if (group) {
        group.quantity += Number(item.quantity);
      } else {
        groups.set(key, {
          product: String(item.title || item.product_title || '').replace(/[\r\n]+/g, ' '),
          cm: String(Number(cm)).replace('.', ','),
          quantity: Number(item.quantity)
        });
      }
    });
    return Array.from(groups.values(), values => config.line.replace(/\{(product|cm|quantity)\}/g, (_, key) => values[key]));
  }

  function buildNote(state, note = state.note) {
    const original = customerNote(note);
    const lines = extensionLines(state.items);
    return [original, lines.join('\n')].filter(Boolean).join('\n\n');
  }

  function reflect(state) {
    cart = state;
    document.documentElement.dataset.ksExtensionCart = String(extensionLines(state.items).length > 0);
    document.querySelectorAll('textarea[name="note"], input[name="note"]').forEach(input => {
      const value = state.note || '';
      if (input !== document.activeElement && input.value !== value) input.value = value;
    });
    reflectDrawerNote();
  }

  function reflectDrawerNote() {
    const preview = document.querySelector('[data-essential-cart-element="order-note-saved-text"]');
    if (!preview) return;
    const note = buildNote(cart, customerDraft === undefined ? cart.note : customerDraft);
    if (preview.textContent !== note) preview.textContent = note;
  }

  function watchDrawerNote() {
    const portal = document.getElementById('essential-cart-drawer-portal');
    if (!portal) return false;
    new MutationObserver(reflectDrawerNote).observe(portal, { childList: true, subtree: true, characterData: true });
    reflectDrawerNote();
    return true;
  }

  function enqueue(work) {
    const task = queue.catch(() => {}).then(work);
    queue = task;
    return task;
  }

  async function readCart() {
    const response = await request(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error(config.error);
    return response.json();
  }

  async function saveNote(state) {
    const note = buildNote(state, customerDraft === undefined ? state.note : customerDraft);
    if (note !== (state.note || '')) {
      const response = await request(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note })
      });
      if (!response.ok) throw new Error(config.error);
      state = await response.json();
      if (state.errors || state.status || state.note !== note) throw new Error(config.error);
    }
    reflect(state);
    return state;
  }

  function ensure() {
    return enqueue(async () => saveNote(await readCart()));
  }

  window.fetch = function(input, options) {
    const url = new URL(typeof input === 'string' || input instanceof URL ? input : input.url, location.href);
    const method = options?.method || (input instanceof Request ? input.method : 'GET');
    if (url.origin !== location.origin || method.toUpperCase() !== 'POST' || !/\/cart\/(add|change|update|clear)(?:\.js|\.json)?\/?$/.test(url.pathname)) {
      return request(input, options);
    }
    return enqueue(async () => {
      if (/\/cart\/update(?:\.js|\.json)?\/?$/.test(url.pathname) && typeof options?.body === 'string') {
        try {
          const body = JSON.parse(options.body);
          if (Object.prototype.hasOwnProperty.call(body, 'note') && !body.updates && !body.items) {
            body.note = buildNote(cart, customerDraft === undefined ? body.note : customerDraft);
            options = { ...options, body: JSON.stringify(body) };
          }
        } catch {}
      }
      const response = await request(input, options);
      if (!response.ok) return response;
      try {
        const payload = await response.clone().json();
        if (payload.errors || payload.status) return response;
        const fullCart = Array.isArray(payload.items) && typeof payload.item_count === 'number';
        const saved = await saveNote(fullCart ? payload : await readCart());
        if (fullCart && payload.note !== saved.note) {
          const headers = new Headers(response.headers);
          headers.delete('content-length');
          headers.delete('content-encoding');
          return new Response(JSON.stringify({ ...payload, note: saved.note }), {
            status: response.status, statusText: response.statusText, headers
          });
        }
      } catch {
        document.documentElement.dataset.ksExtensionCart = 'true';
      }
      return response;
    });
  };

  document.addEventListener('input', event => {
    if (event.target.matches('textarea[name="note"], input[name="note"], [data-essential-cart-element="order-note-textarea"]')) {
      customerDraft = customerNote(event.target.value);
    }
  });

  async function beforeCheckout(resume) {
    if (checkoutBusy) return;
    checkoutBusy = true;
    try {
      await ensure();
      document.querySelectorAll('[name="note"]').forEach(input => { input.value = cart.note || ''; });
      resume();
    } catch {
      window.alert(config.error);
    } finally {
      checkoutBusy = false;
    }
  }

  document.addEventListener('click', event => {
    const target = event.target.closest('a[href], button, input[type="submit"]');
    if (!target) return;
    if (replayClicks.has(target)) { replayClicks.delete(target); return; }
    const href = target.getAttribute('href');
    const checkoutLink = href && /\/checkout(?:\/|\?|$)/.test(new URL(href, location.href).pathname);
    if (target.name !== 'checkout' && !checkoutLink && !target.matches('[data-essential-cart-checkout]')) return;
    if (target.disabled || event.defaultPrevented) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    beforeCheckout(() => {
      if (target.form) replayForms.add(target.form);
      replayClicks.add(target);
      target.click();
    });
  }, true);

  document.addEventListener('submit', event => {
    if (replayForms.has(event.target)) { replayForms.delete(event.target); return; }
    if (event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    beforeCheckout(() => {
      replayForms.add(event.target);
      event.target.requestSubmit(event.submitter);
    });
  }, true);

  document.addEventListener('formdata', event => {
    if (event.formData.has('checkout')) event.formData.set('note', cart.note || '');
  });

  window.KarmaBraceletNotes = { ensure, buildNote };
  reflect(cart);
  if (!watchDrawerNote()) {
    const observer = new MutationObserver(() => { if (watchDrawerNote()) observer.disconnect(); });
    observer.observe(document.body, { childList: true });
  }
  if (extensionLines(cart.items).length || customerNote(cart.note) !== String(cart.note || '').trim()) ensure().catch(() => {});
})();
